import { Component, OnInit } from "@angular/core";

import { User } from "../../interfaces/user";
import { SessionService } from "../../services/session/session.service";
import { UserService } from "../../services/user/user.service";
import {
  SubscriptionService,
  Address,
} from "../../services/subscription/subscription.service";

@Component({
  selector: "app-subscription",
  templateUrl: "./subscription.component.html",
  styleUrls: ["./subscription.component.scss"],
})
export class SubscriptionComponent implements OnInit {
  isLoading = false;
  user: User;
  address: Address;

  constructor(
    private readonly SessionService: SessionService,
    private readonly UserService: UserService,
    private readonly SubscriptionService: SubscriptionService
  ) {}

  /**
   * Is `true` when the user has an active license.
   */
  private get hasActiveLicense() {
    const { licenseStatus, licensePeriodEnd } = this.user;

    switch (licenseStatus) {
      case "active":
      case "trialing":
        return true;
      case "company":
        return new Date(licensePeriodEnd) > new Date();
      case "canceled":
      default:
        return false;
    }
  }

  /**
   * Runs when the component is mounted.
   */
  async ngOnInit() {
    this.isLoading = true;

    // Gets the user and saves their license status for the session.
    this.user = (await this.UserService.getUser()) as User;
    this.SessionService.setHasActiveLicense(this.hasActiveLicense);

    // Gets the user's billing address if they have a Stripe account.
    if (this.user.stripeId) {
      this.address = await this.SubscriptionService.getAddress();
    }

    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/subscription/subscription.component.ts